import axios from 'axios';
import type {
  AnsweringSubscriptionJsonType,
  AnsweringSubscriptionLevel,
} from '@bb/domain/dist/types';

type FindActiveSubscriptionDTO = AnsweringSubscriptionJsonType | undefined;

const findActiveSubscription = async (params: {
  subscriptionLevel: AnsweringSubscriptionLevel;
  userId?: string;
}) => {
  const { data } = await axios.get<FindActiveSubscriptionDTO>(
    '/answering_subscription/find_active',
    {
      params,
    },
  );

  if (data) return data;

  return undefined;
};

export default findActiveSubscription;
